/* bureau bravo: multiplies the displayed product price by the selected
   quantity step (product.metafields.product.quantity_steps). Unit price
   (€/l) is left untouched. Loaded from snippets/quantity-steps-selector. */
(() => {
  if (window.__bbStepsPrice) return;
  window.__bbStepsPrice = true;

  const format = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '{{amount_with_comma_separator}} €';

  const formatMoney = (cents) => {
    const value = cents / 100;
    const match = format.match(/\{\{\s*(\w+)\s*\}\}/);
    const key = match ? match[1] : 'amount';
    const two = { minimumFractionDigits: 2, maximumFractionDigits: 2 };
    let amount;
    switch (key) {
      case 'amount_no_decimals': amount = Math.round(value).toLocaleString('en-US'); break;
      case 'amount_with_comma_separator': amount = value.toLocaleString('de-DE', two); break;
      case 'amount_no_decimals_with_comma_separator': amount = Math.round(value).toLocaleString('de-DE'); break;
      case 'amount_with_space_separator': amount = value.toLocaleString('fr-FR', two); break;
      case 'amount_with_apostrophe_separator': amount = value.toLocaleString('de-CH', two); break;
      default: amount = value.toLocaleString('en-US', two);
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount).replace(/<[^>]+>/g, '');
  };

  const setPriceText = (el, text) => {
    if (!el) return;
    [...el.childNodes].forEach((node) => { if (node.nodeType === Node.TEXT_NODE) node.remove(); });
    el.append(document.createTextNode(text));
  };

  // Apps (Globo Product Options) rewrite the price element once they initialise;
  // re-apply our total whenever it disappears from the element.
  const keepApplied = (el, getTotal, reapply) => {
    if (!el || el.__bbObserved) return;
    el.__bbObserved = true;
    new MutationObserver(() => {
      const total = getTotal();
      if (total && !el.textContent.includes(total)) reapply();
    }).observe(el, { childList: true, characterData: true, subtree: true });
  };

  const bind = (selector) => {
    if (selector.__bbBound) return;
    selector.__bbBound = true;

    const unitPrice = parseInt(selector.dataset.bbVariantPrice, 10);
    const compareAt = parseInt(selector.dataset.bbCompareAtPrice, 10);
    const input = selector.querySelector('input');
    if (!Number.isFinite(unitPrice) || !input) return;

    const info = selector.closest('.product-info');
    const priceList = info && info.querySelector('price-list.price-list--product');
    const salePrice = priceList && priceList.querySelector('sale-price');
    const comparePrice = priceList && priceList.querySelector('compare-at-price');
    const stickyPrice = document.querySelector('product-sticky-bar sale-price');

    // Hint sits in the same line as the theme's tax notice ("12 × 11,90 € inkl. MwSt.")
    // when that notice is enabled, otherwise in its own muted line.
    let hint = priceList && priceList.parentElement.querySelector('[data-bb-steps-hint]');
    if (priceList && !hint) {
      hint = document.createElement('span');
      hint.setAttribute('data-bb-steps-hint', '');
      const notice = priceList.nextElementSibling;
      if (notice && notice.matches('p.text-sm.text-subdued')) {
        notice.prepend(hint, document.createTextNode(' '));
      } else {
        const line = document.createElement('p');
        line.className = 'text-sm text-subdued';
        line.append(hint);
        priceList.insertAdjacentElement('afterend', line);
      }
    }

    let lastTotal = '';
    const update = () => {
      const qty = parseInt(input.value, 10);
      if (!Number.isFinite(qty) || qty < 1) return;
      lastTotal = formatMoney(unitPrice * qty);
      setPriceText(salePrice, lastTotal);
      setPriceText(stickyPrice, lastTotal);
      if (comparePrice && Number.isFinite(compareAt)) setPriceText(comparePrice, formatMoney(compareAt * qty));
      if (hint) hint.textContent = `${qty} × ${formatMoney(unitPrice)}`;
    };

    input.addEventListener('change', update);
    update();
    keepApplied(salePrice, () => lastTotal, update);
    keepApplied(stickyPrice, () => lastTotal, update);
  };

  const init = () => document.querySelectorAll('quantity-steps-selector[data-bb-variant-price]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
